import BaseService from "./base.service";
import { Utilities } from "../../utils/utilities";
import { UserDTO, UserInfoDTO } from "@models/*";
import axios from "axios";

export interface IGraphService {
  getCurrentUserInfo(getUserInfoRq?: IGetUserInfoRequest): Promise<UserDTO>;
  getAzureADCurrentUserEmail(): Promise<string>;
  getUserPhoto(userId: string): Promise<Blob | null>
}
export interface IGetUserInfoRequest {
  loginName?: string;
  email?: string;
  properties?: string;
}

export class GraphService extends BaseService implements IGraphService {

  public async getUserPhoto(userId: string): Promise<Blob | null> {
    try {
      const token = await this.getAccessToken();
      const response = await axios.get(`https://graph.microsoft.com/beta/users/${userId}/photo/$value`, {
        headers: {
          Authorization: `Bearer ${token}`, 
        },
        responseType: "blob", 
      });

      return response.data; 
    } catch (error) {
      console.error("Error fetching user photo:", error);
      return null; 
    }
  }


  public async getCurrentUserInfo(
    getUserInfoRq?: IGetUserInfoRequest
  ): Promise<UserDTO> {
    var gpContext = await this.getGraph();
    if (!Utilities.isNullObject(getUserInfoRq)) {
      if (!Utilities.isNullObject(getUserInfoRq.email)) {
        const currentUser = await gpContext.users
          .getById(getUserInfoRq.email)
          .select(getUserInfoRq.properties)
          .get<UserInfoDTO>();
        let userGroups = await gpContext.users
          .getById(getUserInfoRq.email)
          .memberOf();
        return { currentUser, userGroups };
      }
    }
    return null;
  }
  public async getAzureADCurrentUserEmail(): Promise<string> {
    const authMe = await this.getAdUserAuthMe();
    return authMe.user_id;
  }
}
